import React from 'react'
import MaskedInput from 'react-text-mask'
export const DateField = ({ inputRef, ...rest }) => {
  return (
    <MaskedInput
      {...rest}
      style={{ textTransform: 'uppercase' }}
      mask={[
        /[0-3]/,
        /[0-9]/,
        '/',
        /[0-1]/,
        /[0-9]/,
        '/',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
      ]}
      placeholderChar={'\u2000'}
    />
  )
}

export default DateField



// WEBPACK FOOTER //
// ./src/components/Fields/DateField.js